import { useMutation, useQueryClient } from "@tanstack/react-query";
import { undismissAlert } from "../../../api/alertsApi";

export const useUndismissAlert = () => {
  const queryClient = useQueryClient();
  return useMutation((alertId: string) => undismissAlert(alertId), {
    // Same reasoning as useUnsnoozeAlert - refetch the ["alerts"] prefix so the main list, the
    // Dismissed list, and every useDashboardAlerts() entry all pick up the change.
    onSuccess: () => queryClient.invalidateQueries(["alerts"]),
  });
};
